import axios from "axios";

export const getTwilioWorkersList = async (productId: string, subscriptionId: string, accountSid: string) => {
	return await axios.post(`/api/v1/${productId}/Twilio/Workers/${subscriptionId}/${accountSid}/GetWorkersForAccount`);
};
